import { whiteLocaleList } from '@elem/compPage/remote-installation-video-support-form/config';
import { GetServerSidePropsContext } from 'next';
import RemoteInstallForm from '@elem/compPage/remote-installation-video-support-form';
import PageLayout from '@/components/PageLayout';
import { redirectTo404 } from '@/utils/redirect404';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';

export default function EfQuoteForm({ SEO, locale }: any) {
    const { t } = useLang('questionnaire');

    return (
        <PageLayout theme="white">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname="remote-installation-video-support-form" />
            <RemoteInstallForm />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: { locale },
    };
}
